import { c as _c } from "react/compiler-runtime";
import { HotelSearchSummaryViewPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.types";
import { MaterialIcon } from "@website/icons/material";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelSearchSummaryContent: FC<HotelSearchSummaryViewPropertiesType> = properties => {
  const $ = _c(24);
  const {
    searchType: t0,
    cityTitle,
    dateFrom,
    dateTo,
    nightCount
  } = properties;
  const searchType = t0 === undefined ? "city" : t0;
  const router = useRouter();
  const isCompleteInfo = dateFrom && dateTo;
  let t1;
  if ($[0] !== dateFrom || $[1] !== dateTo || $[2] !== nightCount || $[3] !== router || $[4] !== searchType) {
    t1 = dateFrom && dateTo ? <span className="lg:text-on-surface-high-emphasis min-w-24 truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center" data-testid="search_date_range">{`${dateFrom} - ${dateTo} ${searchType === "hotel" ? `${numberConvert(nightCount, {
        locale: router.locale
      })} شب` : ""}`}</span> : <span className={`lg:text-on-surface-high-emphasis text-secondary min-w-24 truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center ${searchType === "hotel" ? "text-caption lg:text-subtitle-2 text-on-surface-high-emphasis" : "text-overline lg:text-subtitle-2 text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis"}`} data-testid="search_date_range">تعیین بازه اقامت</span>;
    $[0] = dateFrom;
    $[1] = dateTo;
    $[2] = nightCount;
    $[3] = router;
    $[4] = searchType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const DateRange = t1;
  const t2 = `bg-outline-thick border-outline-thin hover:shadow-8 flex w-full items-center justify-between gap-4 rounded-full border px-4 py-px transition-shadow duration-200 ease-in-out lg:pl-px ${searchType === "hotel" ? "h-[48px] bg-white lg:h-auto lg:max-w-max" : "bg-outline-thick lg:mx-auto lg:max-w-max"} ${isCompleteInfo ? "" : "border-secondary border-2"}`;
  let t3;
  if ($[6] !== cityTitle || $[7] !== searchType) {
    t3 = (searchType === "city" || searchType === "category") && <><h1 className="lg:text-on-surface-high-emphasis text-body-2 text-on-surface-high-emphasis lg:text-subtitle-2 truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center" data-testid="page_title">{searchType === "city" ? cityTitle ? `رزرو هتل های ${cityTitle}` : <Skeleton height={20} shape="rectangle" /> : cityTitle ?? <Skeleton height={20} shape="rectangle" />}</h1><div className="bg-outline-thin hidden h-[24px] w-px lg:block" /></>;
    $[6] = cityTitle;
    $[7] = searchType;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = `lg:text-on-surface-high-emphasis truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center ${searchType === "hotel" ? "text-caption lg:text-subtitle-2 text-on-surface-high-emphasis" : "text-overline lg:text-subtitle-2 text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis"}`;
  let t5;
  if ($[9] !== DateRange || $[10] !== t4) {
    t5 = <div className={t4}>{DateRange}</div>;
    $[9] = DateRange;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="grid grow py-1.5 lg:flex lg:flex-row lg:items-center lg:gap-4">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis flex size-6 shrink-0 grow-0 items-center justify-center rounded-full text-2xl lg:size-9 ${isCompleteInfo ? "lg:text-on-color-high-emphasis text-on-surface-medium-emphasis bg-auto" : ""} ${isCompleteInfo && searchType === "hotel" ? "lg:bg-secondary" : isCompleteInfo && searchType === "city" ? "lg:bg-primary" : ""} `;
  const t8 = `${isCompleteInfo ? "text-on-surface-medium-emphasis lg:text-white" : ""}`;
  let t9;
  if ($[15] !== t8) {
    t9 = <MaterialIcon className={t8} name="search" />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t2 || $[22] !== t6) {
    t11 = <div className={t2}>{t6}{t10}</div>;
    $[20] = t10;
    $[21] = t2;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};